import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';   
import { ReceptionLoginComponent } from './page/reception-login/reception-login.component';
import { OidcGuard } from '../../biometric/domain/guard/cas.guard';

const routes: Routes = [
  { path: '', 
    canActivate: [OidcGuard],
    component: ReceptionLoginComponent,
    data: {
      queryParams: ['customerId','conversationId','channelId','chatbotId']
  } 
}
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class B2cRoutingModule { }
